import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';

import { Switch, FormLabel, Grid } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

import { setNotifications } from '../../actions/notification.actions';

const Notifications = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const notifications = useSelector(state => state.employee.notifications);

  const useStyles = makeStyles({
    label: {
      margin: 'auto 0'
    }
  });

  const classes = useStyles();

  const changeNotifications = event => {
    dispatch(setNotifications( { notifications: event.target.checked }));
  };

  return (
    <Grid item container direction="row">
      <FormLabel className={ classes.label }>
        { t('settings.notifications.label') }
      </FormLabel>
      <Switch
        checked={ notifications || false }
        onChange={ changeNotifications }
      />
    </Grid>
  );
};

export default Notifications;
